import { Injectable, Inject, InjectionToken } from '@angular/core';
import { noop, firstValueFrom } from 'rxjs';
import { EstensaBusWrapperService } from './angularjs/estensa-bus-wrapper.service';
import {
    THIRD_PART_POST_MESSAGES,
    estensaPostMessage,
    THIRD_PART_STATUS_CODE,
    THIRD_PART_STATUS_DETAIL,
    placerOrderData
} from 'estensa-module';
import { ServerRootService } from '@se/se.ui.html5';
import { TranslateService } from '@ngx-translate/core';
import { ThirdPartSupportService } from './third-part-support.service';

export const ESTENSA_MODULE_THIRD_PART_POST_MESSAGE_SERVICE =
    new InjectionToken('estensa.module.third.part.post.message.service');

export interface IThirdPartPostMessageServiceNg1 {
    initService(): void;
    destroy(): void;
}

@Injectable()
export class NullThirdPartPostMessageService implements IThirdPartPostMessageServiceNg1 {
    initService = noop;
    destroy = noop;
}

@Injectable({
    providedIn: 'root',
})
export class ThirdPartPostMessageService extends ServerRootService{

    // constructor

    constructor(
        @Inject(ESTENSA_MODULE_THIRD_PART_POST_MESSAGE_SERVICE) private thirdPartPostMessageService: IThirdPartPostMessageServiceNg1,
        private estensaBusService: EstensaBusWrapperService,
        private translate: TranslateService,
        private thirdPartSupportService: ThirdPartSupportService)
    {
        super();
    }

    // public functions

    initService() {
        this.estensaBusService.busDataFired.subscribe((busMessage) => {
            if (busMessage.messageType == 'ESTENSA_THIRD_PART')
                this.onThirdPartMessage(busMessage.data);
            else if (busMessage.messageType == 'ESTENSA_THIRD_PART_NAVIGATE') {
                this.thirdPartSupportService.goToReporting(busMessage.data.examinationId);
            }
        });

        return this.thirdPartPostMessageService.initService();
    }

    destroy() {
        return this.thirdPartPostMessageService.destroy();
    }

    private async onThirdPartMessage(e: MessageEvent) {
        if (!!e.data.estensaPostMessageType) {
            let messageRq: estensaPostMessage = e.data;

            let messageRsp: estensaPostMessage = {
                estensaPostMessageType: THIRD_PART_POST_MESSAGES.UNKNOWN,
                estensaPostMessageId: -1
            }

            switch (messageRq.estensaPostMessageType) {
                case THIRD_PART_POST_MESSAGES.CAN_SAVE_CONTEXT_RQ:
                    messageRsp = await this.onCanSaveContextRq(messageRq.placerOrderData);
                    break;
                case THIRD_PART_POST_MESSAGES.SAVE_CONTEXT_RQ:
                    messageRsp = await this.onSaveContextRq(messageRq.placerOrderData);
                    break;
                case THIRD_PART_POST_MESSAGES.DISCARD_CONTEXT_RQ:
                    messageRsp = await this.onDiscardContextRq(messageRq.placerOrderData);
                    break;
                case THIRD_PART_POST_MESSAGES.LOAD_CONTEXT_RQ:
                    messageRsp = await this.onLoadContextRq(messageRq.placerOrderData);
                    break;
                case THIRD_PART_POST_MESSAGES.PING:
                    messageRsp.estensaPostMessageType = THIRD_PART_POST_MESSAGES.PONG;
                    messageRsp.statusCode = THIRD_PART_STATUS_CODE.SUCCESS;
                    messageRsp.statusDetail = THIRD_PART_STATUS_DETAIL.SUCCESS;
                    break;
                default:
                    messageRsp.statusCode = THIRD_PART_STATUS_CODE.UNKNOWN;
                    messageRsp.statusDetail = THIRD_PART_STATUS_DETAIL.UNKNOWN;
                    return;
            }

            // Assegno lo stesso id della richiesta
            messageRsp.estensaPostMessageId = messageRq.estensaPostMessageId;

            // Traduco se necessario
            if (!!messageRsp.statusDetail)
                messageRsp.statusDetail = this.translate.instant(messageRsp.statusDetail);

            // Spedisco indietro
            if (!(e.source instanceof MessagePort) && !(e.source instanceof ServiceWorker)) {
                e.source?.postMessage(messageRsp, '*');
            }
        }
    }

    private async onCanSaveContextRq(_: placerOrderData) {
        return await new Promise<estensaPostMessage>(
            resolve => this.estensaBusService.notify({ messageType: 'CpCanSave', data: { reply: resolve } }));
    }

    private async onSaveContextRq(_: placerOrderData) {
        return await new Promise<estensaPostMessage>(
            resolve => this.estensaBusService.notify({ messageType: 'CpSave', data: { reply: resolve } }));
    }

    private async onDiscardContextRq(_: placerOrderData) {
        return await new Promise<estensaPostMessage>(
            resolve => this.estensaBusService.notify({ messageType: 'CpDiscard', data: { reply: resolve } }));
    }

    private async onLoadContextRq(data: placerOrderData) {
        let examinationId = await firstValueFrom(this.thirdPartSupportService.getExaminationIdFromPlacerOrderData(data));

        return  await new Promise<estensaPostMessage>(
            resolve => this.estensaBusService.notify({
                messageType: 'CpLoadContext',
                data: {
                    examinationId: examinationId,
                    reply: resolve
                }
            }));
    }

}
